import type { FC, ReactNode } from 'react'
import { useMemo } from 'react'
import ModelCard from 'src/components/GenerationModel/ModelCard'
import { cx } from 'src/utils/cx'
import type {
  BaseModelListInfiniteScrollProps,
  ModelInfiniteScrollContentProps,
} from '.'

const ModelGrid: FC<
  Partial<
    ModelInfiniteScrollContentProps & {
      className?: string
      lastView?: ReactNode
      modifyModelElements?: BaseModelListInfiniteScrollProps['modifyModelElements']
    }
  >
> = ({
  scene,
  models,
  onModelClick,
  loading,
  className,
  lastView,
  pageSize = 24,
  modifyModelElements = arg => arg,
  mutateModels,
}) => {
  const content = useMemo(() => {
    if (!models) {
      return null
    }
    const elements = models.map(model => {
      return (
        <ModelCard
          key={model.id}
          model={model}
          link
          scene={scene}
          onClick={() => onModelClick?.(model)}
          mutateModels={mutateModels}
        />
      )
    })
    return modifyModelElements(elements, {
      gridItemType: 'model',
    })
  }, [scene, models, onModelClick, modifyModelElements])

  return (
    <div
      className={cx(
        'w-full grid content-start mt-4',
        'grid-cols-2 gap-2',
        'lg:grid-cols-3 lg:gap-3',
        'xl:grid-cols-4',
        className,
      )}
    >
      {content}
      {lastView}
      {loading &&
        Array.from({ length: pageSize }).map((_, index) => {
          return <ModelCard key={index} />
        })}
    </div>
  )
}

export default ModelGrid
